import React, { useContext } from "react";

import { mdiReload } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

import { APP_TOOLTIP_ID } from "@/src/constants/tooltip";

import {
  WebSocketConnectionStatus,
  WebSocketContext,
} from "../../contexts/WebSocket";

import type { JSX } from "react";

export default function WebSocketStatus(): JSX.Element | null {
  const { status } = useContext(WebSocketContext);
  const { t } = useTranslation("editor-errors");

  const renderStatus = (): JSX.Element | null => {
    switch (status) {
      case WebSocketConnectionStatus.Error:
        return (
          <div className="flex shrink-0 items-center">
            <div
              className="bg-destructive text-primary-foreground flex cursor-pointer items-center gap-[0.3125rem] rounded-[0.3125rem] p-[0.3125rem]"
              onClick={(): void => {
                window.location.reload();
              }}
            >
              {t("websocketError")}
              <Icon path={mdiReload} size={0.625} />
            </div>
          </div>
        );
      case WebSocketConnectionStatus.Uninstantiated:
      case WebSocketConnectionStatus.Connecting:
      case WebSocketConnectionStatus.Closed:
        return (
          <div
            className="flex shrink-0 items-center"
            data-tooltip-content="Connecting to server..."
            data-tooltip-id={APP_TOOLTIP_ID}
            data-tooltip-place="left"
          >
            <div className="bg-status-pause size-[0.46875rem] rounded-[0.3125rem] p-[0.3125rem]" />
          </div>
        );
      default:
        return null;
    }
  };

  return renderStatus();
}
